import { render, staticRenderFns } from "./zcTable.vue?vue&type=template&id=3558a488&scoped=true"
import script from "./zcTable.vue?vue&type=script&lang=js"
export * from "./zcTable.vue?vue&type=script&lang=js"
import style0 from "./zcTable.vue?vue&type=style&index=0&id=3558a488&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3558a488",
  null
  
)

export default component.exports